// extracted by mini-css-extract-plugin
module.exports = {"PopUpBox":"ApplyJob_PopUpBox__3GJ5c","Box":"ApplyJob_Box__2cAqk","Button":"ApplyJob_Button__bhowB","CloseIcon":"ApplyJob_CloseIcon__1bWrn"};